import React, {
  useEffect,
  useState,
} from 'react';

import { communicationAPI } from 'api/communicationAPI';
import CloseIcon from 'assets/images/icon/CloseIcon';
import PlusIconDark from 'assets/images/icon/PlusIconDark';
import StarFill from 'assets/images/icon/Star_fill';
import StarEmpty from 'assets/images/icon/StarEmpty';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import { FaUser } from 'react-icons/fa6';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';

const arr = [1, 2, 3, 4, 5];

const CoPopup = (props) => {
    const [ratingValue, setRatingValue] = useState(0);
    const [feedback, setFeedback] = useState("");
    const mouseOver = (index) => {
        setRatingValue(index);
    };

    const returnData = (date) => {
        // const c = cloneDeep(date)?.map((item, index) => {
        //     if (index === 1) {
        //         item = item - 1;
        //     }
        //     return item;
        // });
        // let ms = dayjs(Date.UTC.apply(null, c?.slice(0, 6)))
        //     .utc()
        //     .locale("en")
        //     .format("MMM DD, YYYY");
        return date;
    };

    const getFormData = () => {
        const homeworkFeedback = {
            feedback: feedback,
            rating: ratingValue + 1,
        };
        const formData = new FormData();

        // formData.append("email", props?.userData?.email);
        formData.append("homeworkFeedback", JSON.stringify(homeworkFeedback));

        return formData;
    };

    const putHomework = async () => {
        await communicationAPI
            .putHomework(props?.data?.id, {
                data: {
                    feedback: feedback,
                    rating: ratingValue + 1,
                    isCompleted: true,
                },
            })
            .then((res) => {
                console.log("suc", res);
                if (!isEmpty(res?.feedback)) {
                    props.onClickPopup();
                }
            });
    };

    const handleDownload = (fileUrl, fileName) => {
        // Create a link element
        const link = document.createElement("a");
        link.href = fileUrl;
        link.target = "_blank";
        link.download = fileName || "homework_file";
        // Simulate a click on the link to trigger the download
        link.click();
    };

    useEffect(() => {
        setFeedback(props?.data?.feedback);
    }, []);

    useEffect(() => {
        if (!isEmpty(props?.data?.rating)) {
            setRatingValue(props?.data?.rating - 1);
        }
    }, []);

    console.log("props?.data", props?.data);

    return (
        <Container>
            <Title>
                <h1>Your Feedback</h1>
            </Title>
            <Dvider />
            <Contents className={"popup"}>
                <TextArea>
                    <h2>{props?.data?.title || "Title"}</h2>
                    <Dvider />
                    <TextAreaContents>
                        <Avatar>
                            {!isEmpty(props?.data?.user?.profileImage?.url) ? (
                                <img
                                    src={
                                        props?.data?.user?.profileImage?.url ||
                                        "/images/userFeedback.png"
                                    }
                                    alt=""
                                />
                            ) : (
                                <FaUser />
                            )}
                        </Avatar>
                        <TextWrap>
                            <span>
                                {props?.data?.user?.lastName || ""}&nbsp;
                                {props?.data?.user?.firstName || ""}
                            </span>
                            <b>{returnData(props?.data?.createdDatetime)}</b>
                            <p>{props?.data?.content || "content"}</p>
                        </TextWrap>
                    </TextAreaContents>
                </TextArea>
            </Contents>
            <div
                className={"warp"}
                style={{padding:"0 20px", marginBottom:15}}>
            {
                !isEmpty(props?.data?.homeworkFile?.url) &&
                <InputContents>
                <InputIcons
                    onClick={() => {
                        handleDownload(
                            props?.data?.homeworkFile?.url,
                            props?.data?.homeworkFile?.fileName
                        );
                    }}
                >
                    <PlusIconDark />
                    <p>Homework File</p>
                </InputIcons>
            </InputContents>
            }
            </div>
        
            <Dvider />
            <Rating>
                <RatingHeader>
                    <h2>Rating</h2>
                    <Stars>
                        {arr.map((item, index) => (
                            <Star
                                onMouseOver={() => {
                                    if (props?.data?.communicationStep === "COMPLETE") return;
                                    mouseOver(index);
                                }}
                            >
                                {index <= ratingValue ? <StarFill /> : <StarEmpty />}
                            </Star>
                        ))}
                    </Stars>
                    <span style={{ fontWeight: 400, fontSize: 16 }}>
                        <b>{ratingValue + 1}</b> stars
                    </span>
                </RatingHeader>
                <h4>Write your feedback</h4>
                <textarea
                    readOnly={props?.data?.communicationStep === "COMPLETE"}
                    value={feedback}
                    onChange={(e) => {
                        setFeedback(e.target.value);
                    }}
                />
            </Rating>
            <CloseButton
                onClick={() => {
                    props.onClickPopup();
                }}
            >
                <CloseIcon />
            </CloseButton>
            {props?.data?.communicationStep !== "COMPLETE" && (
                <Send>
                    <span
                        onClick={async () => {
                            await putHomework();
                        }}
                    >
                        Send
                    </span>
                </Send>
            )}
        </Container>
    );
};
export default CoPopup;

const Container = styled.div`
    width: 90%;
    max-width: 900px;
    overflow: hidden;
    background: #fff;
    border-radius: 15px;
    position: absolute;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    @media screen and (max-width: 768px) {
        @supports (-webkit-touch-callout: none) {
            /* Safari 스타일 */
            top: calc(100vh - (100vh - 30px));
            transform: translate(-50%,0%);
        }
    }

    h1 {
        font-size: 28px;
        font-weight: 700;
    }

`;

const Title = styled.div`
    padding: 23px 20px 20px 20px;
`;

const Dvider = styled.div`
    width: 100%;
    background: #333;
    opacity: 0.1;
    height: 1px;
`;

const Contents = styled.div`
    margin-top: 20px;
    padding: 0 20px 15px 20px;
`;
const Avatar = styled.div`
    min-width: 60px;
    width: 60px;
    margin-right: 15px;
    svg {
        border-radius: 50%;
        width: 60px;
        height: 60px;
        background: #ddd;
        path {
            fill: #eee;
        }
    }
    img {
        width: 60px;
        height: 60px;
        border-radius: 100%;
        object-fit: contain;
        min-width: 60px;
        min-height: 60px;
    }
`;
const TextArea = styled.div`
    flex: 1;
    background: #f5f5f5;
    border-radius: 15px;
    h2 {
        line-height: 29px;
        padding:10px 15px;
        font-size: 22px;
        font-weight: 700;
    }
`;
const CloseButton = styled.div`
    background: #333;
    position: absolute;
    width: 60px;
    cursor: pointer;
    right: 0;
    top: 0;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 0 0 0 10px;
    transition: all 0.2s;
    &:hover{
        svg{
            transition: all 0.2s;
            transform: scale(1.1);    
        }
    }
    svg {
        width: 30px;
        height: 30px;
    }
`;
const TextAreaContents = styled.div`
    display: flex;
    padding: 15px;
`;
const TextWrap = styled.div`
    display: flex;
    flex-direction: column;
    height: 125px;
    overflow-y: scroll;
    scrollbar-width: thin;
    scrollbar-color: #33333320 transparent;
    &::-webkit-scrollbar {
        width: 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.3);
        border: none;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }
    span {
        font-size: 22px;
        font-weight: 600;
        line-height: 27.5px;
    }
    p {
        line-height: 28px;
        font-size: 18px;
        font-weight: 400;
    }
    b {
        opacity: 0.6;
        font-size: 14px;
        display: inline-block;
        margin-bottom: 4px;
    }
`;
const Rating = styled.div`
    padding: 20px;
    width: 100%;
    h4 {
        font-size: 22px;
        margin-bottom: 15px;
    }
    textarea {
        background: #f5f5f5;
        border: solid 1px #33333330;
        border-radius: 15px;
        width: 100%;
        height: 100px;
        outline: none;
        resize: none;
        padding: 15px;
    }
`;
const RatingHeader = styled.div`
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    h2 {
        font-size: 22px;
        margin-right: 30px;
    }
    span {
        b {
            width: 12px;
            font-weight: 400;
        }
        display: flex;
        height: 100%;
        padding-top: 3px;
        width: 54px;
    }
`;
const Stars = styled.div`
    display: flex;
    align-items: center;
`;
const Star = styled.div`
    display: flex;
    align-items: center;
    margin-right: 5px;
    cursor: pointer;
`;
const Send = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    padding-bottom: 27px;
    font-size: 18px;
    background: #fff;
    span {
        cursor: pointer;
        background: #ddc160;
        color: #fff;
        padding: 18px 116px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
    }
`;
const InputIcons = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    justify-content: center;
    margin-bottom: 11px;
    padding: 0 20px;
    border-radius: 10px;
    &.on {
        background-color: #eff3fe;
        border: 2px solid #276ef1;
    }
    & > div {
        display: flex;
        align-items: center;
        .remove_svg_icon {
        }
        svg {
            &:nth-child(1) {
            }
        }
    }
    p {
        margin-left: 18px;
        font-size: 16px;
        font-weight: 700;
        color: #e0c463;
    }
    span {
        font-weight: 400;
        font-size: 17px;
        line-height: 21px;
        color: #111;
    }
`;
const InputContents = styled.div`
    cursor: pointer;
    position: relative;
    height: 42px;
    width: 100%;
    background: #f5f5f5;
    border: 1px solid #ddd;
    color: #e0c463;
    border-radius: 10px;
    input {
        cursor: pointer;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        z-index: 9;
        opacity: 0;
    }
`;
